import apiClient from './api';
import {
  ContentItemCreateInput,
  ContentItemUpdateInput,
  ContentItemsListParams,
  ContentItemsListResponse,
  ContentItemResponse,
  ContentItemsOrderUpdate
} from '../types/contentItem';

class ContentItemService {
  private baseUrl = '/content-items';

  // 콘텐츠 아이템 목록 조회
  async getContentItems(params?: ContentItemsListParams): Promise<ContentItemsListResponse> {
    const response = await apiClient.get(this.baseUrl, { params });
    return response.data;
  }

  // 콘텐츠 아이템 상세 조회
  async getContentItem(id: number): Promise<ContentItemResponse> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  // 콘텐츠 아이템 생성
  async createContentItem(data: ContentItemCreateInput): Promise<ContentItemResponse> {
    const response = await apiClient.post(this.baseUrl, data);
    return response.data;
  }

  // 콘텐츠 아이템 수정
  async updateContentItem(id: number, data: ContentItemUpdateInput): Promise<ContentItemResponse> {
    const response = await apiClient.put(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  // 콘텐츠 아이템 삭제
  async deleteContentItem(id: number): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete(`${this.baseUrl}/${id}`);
    return response.data;
  }

  // 콘텐츠 아이템 활성화/비활성화 토글
  async toggleContentItem(id: number): Promise<ContentItemResponse> {
    const response = await apiClient.patch(`${this.baseUrl}/${id}/toggle`);
    return response.data;
  }

  // 콘텐츠 아이템 순서 변경
  async updateContentItemsOrder(data: ContentItemsOrderUpdate): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.put(`${this.baseUrl}/order`, data);
    return response.data;
  }
}

const contentItemAPI = new ContentItemService();
export default contentItemAPI;
